import { render, staticRenderFns } from "./interestRatesStep2ogind.vue?vue&type=template&id=64d94a2e"
import script from "./interestRatesStep2ogind.vue?vue&type=script&lang=js"
export * from "./interestRatesStep2ogind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d94a2e')) {
      api.createRecord('64d94a2e', component.options)
    } else {
      api.reload('64d94a2e', component.options)
    }
    module.hot.accept("./interestRatesStep2ogind.vue?vue&type=template&id=64d94a2e", function () {
      api.rerender('64d94a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/interestRatesStep2ogind.vue"
export default component.exports